import React from 'react';
import './JoinHandsSection.css';

function JoinHandsSection() {
  return (
    <section className="join-hands-section">
      <div className="join-hands-container">
        <div className="join-hands-content">
          <h2 className="join-hands-title">
            Let's join hands and make it<br />
            happen with <span className="team-text">the team!</span>
          </h2>
          <a href="/contact" className="join-hands-button">
            Secure your Trip Now
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className="button-arrow"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
        <div className="join-hands-image-container">
          <img 
            src="/assets/imgs/leopard.jpg" 
            alt="Leopard" 
            className="join-hands-image"
            onError={(e) => {
              // Fallback to a placeholder or online image if local image doesn't exist
              e.target.src = 'https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=800&q=80';
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default JoinHandsSection;

